import { PersonWithRoleStatus } from "@/models/share.model";

export const isHealthProOrHealthProStudent = (role : string): boolean => {
     return PersonWithRoleStatus.HealthPro === role || PersonWithRoleStatus.HealthProStudent === role;
}

export const isAssistantOrHealthProStudent = (role : string): boolean => {
     return PersonWithRoleStatus.HealthProAssistant === role || PersonWithRoleStatus.HealthProStudent === role;
}

export const isHealthPro = (role : string): boolean => {
     return PersonWithRoleStatus.HealthPro === role;
}
